import { Chip, Stack } from "@mui/material";
import React from "react";
import { GridValidRowModel } from "@mui/x-data-grid";
import { BillingStatus } from "../../../Core/Api/Types/billing-status";
import { useTranslation } from "react-i18next";

export type TableCellAlertSeverityProps = {
  data: GridValidRowModel;
  color?: "default" | "primary" | "success" | "info" | "error";
};

const TableCellBillingStatus: React.FC<TableCellAlertSeverityProps> = (props) => {
  const { t } = useTranslation();
  const value = props.data.value;
  let color: "default" | "primary" | "success" | "info" | "error" = props.color ? props.color : "primary";
  let text = "";
  text = value as string;

  switch (value) {
    case BillingStatus.TO_BILL:
      color = "info";
      text = t("chip:label.toBill");
      break;
    case BillingStatus.BILLED:
      color = "info";
      text = t("chip:label.billed");
      break;
    case BillingStatus.PAID:
      color = "success";
      text = t("chip:label.paid");
      break;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Chip
        label={text}
        component="span"
        variant="outlined"
        color={color}
        sx={{ ml: 0.5, verticalAlign: "baseline" }}
      />
    </Stack>
  );
};

export default TableCellBillingStatus;
